import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Textarea } from '@wayste/sour-ui';
import { Controller } from 'react-hook-form';
import { CollapsibleCardSectionHeader } from '../../components/roll-off-ordering/CollapsibleCard';
export function PlacementAndDeliverySection({ control, name }) {
    return (_jsxs(_Fragment, { children: [_jsx(CollapsibleCardSectionHeader, { text: "Placement and Delivery*" }), _jsx(Controller, { rules: { required: 'required' }, control: control, name: name, render: ({ field, fieldState }) => {
                    return (_jsx(Textarea, { placeholder: 'Where will you be putting the dumpster?', inputProps: { ...field }, error: fieldState.error }));
                } })] }));
}
//# sourceMappingURL=PlacementAndDeliverySection.js.map